function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import React from 'react';
import { Button, Picker, Toast } from "../../../../common";
import { getCountryCodeList, sendVerifyCode, diffEnvLoginByVerify } from "../../../../service/login";
import "./activity-login.less";
import CountDown from "./count-down";
import MockInventory from "./mock-inventory";
import { getVirtualStock } from "../../../../service/activityService";
import { DownOutline } from 'antd-mobile-icons';
import iphoneImg from "../../../../assets/image/iphone.png";
import emailImg from "../../../../assets/image/email.png";
import iphoneImgFocus from "../../../../assets/image/iphone1.png";
import emailImgFocus from "../../../../assets/image/email1.png";
import fire from "../../../../assets/image/fire.png";
import phoneNum from "../../../../assets/image/phone-num.png";
import verifyNum from "../../../../assets/image/phone-verify.png";
import ProtocolCheck from "./check";
var ActivityLogin = /*#__PURE__*/function (_React$Component) {
  _inherits(ActivityLogin, _React$Component);
  var _super = _createSuper(ActivityLogin);
  function ActivityLogin(props) {
    var _this;
    _classCallCheck(this, ActivityLogin);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "_isMount", false);
    _defineProperty(_assertThisInitialized(_this), "senderTimer", void 0);
    _defineProperty(_assertThisInitialized(_this), "handleTimeOut", function () {
      _this.setState({
        timeout: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "verifyPhoneNum", function (value, areaCode) {
      return areaCode[0] === '86' ? /1[\d]{10}$/.test(value.replace(/\s/g, '')) : /[\d]{5,}$/.test(value.replace(/\s/g, ''));
    });
    _defineProperty(_assertThisInitialized(_this), "verifyVerifyNum", function (value) {
      return /[\d]{6}$/.test(value.replace(/\s/g, ''));
    });
    _defineProperty(_assertThisInitialized(_this), "handleSendVerifyCode", function () {
      var _this$state = _this.state,
        countdown = _this$state.countdown,
        phone = _this$state.phone,
        areaCode = _this$state.areaCode;

      // countdown 为零可以发送
      if (!countdown) {
        // 如果手机号有误
        if (!phone || !_this.verifyPhoneNum(phone, areaCode)) {
          Toast.show({
            content: '请输入正确手机号',
            duration: 3000
          });
          return;
        }
        sendVerifyCode(phone, areaCode[0]).then(function (msg) {
          Toast.show({
            content: msg,
            duration: 1500
          });
          _this.startCountDown();
        }).catch(function (e) {
          Toast.show({
            content: e,
            duration: 3000
          });
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "startCountDown", function () {
      _this.setState({
        countdown: 60,
        hassend: true
      });
      _this.senderTimer = window.setInterval(function () {
        var countdown = _this.state.countdown;
        if (countdown > 0) {
          _this.setState({
            countdown: countdown - 1
          });
        } else {
          _this.setState({
            countdown: 0
          });
          window.clearInterval(_this.senderTimer);
        }
      }, 1000);
    });
    _defineProperty(_assertThisInitialized(_this), "handleLoginAndBind", function () {
      var _this$props$protocolS = _this.props.protocolShow,
        protocolShow = _this$props$protocolS === void 0 ? true : _this$props$protocolS;
      var _this$state2 = _this.state,
        areaCode = _this$state2.areaCode,
        phone = _this$state2.phone,
        verify = _this$state2.verify;
      if (!phone || !_this.verifyPhoneNum(phone, areaCode)) {
        return Toast.show({
          content: "\u8BF7\u8F93\u5165".concat(phone ? '正确的' : '', "\u624B\u673A\u53F7"),
          duration: 3000
        });
      }
      if (!verify || !_this.verifyVerifyNum(verify)) {
        return Toast.show({
          content: "\u8BF7\u8F93\u5165".concat(verify ? '正确的' : '', "\u9A8C\u8BC1\u7801"),
          duration: 3000
        });
      }
      if (!_this.state.checked && protocolShow) {
        return Toast.show({
          content: '请勾选协议',
          duration: 3000
        });
      }
      _this.setState({
        submitLoading: true
      });
      var area = areaCode[0] === '86' ? '' : areaCode[0];
      // 通过验证码登录
      diffEnvLoginByVerify(phone, area, verify).then(function (data) {
        Toast.show({
          icon: 'success',
          content: '登录成功',
          duration: 3000
        });
        _this.setState({
          submitLoading: false
        });
        _this.props.onSuccess && _this.props.onSuccess({
          areaCode: areaCode,
          phone: phone,
          verify: verify
        });
      }).catch(function (e) {
        Toast.show({
          content: e,
          duration: 3000
        });
        _this.setState({
          submitLoading: false
        });
        _this.props.onError && _this.props.onError();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSetFocusStatus", function (inputKey, status) {
      _this.setState(_defineProperty({}, inputKey + '_focus', !!status));
    });
    _this.state = {
      areaCode: ['86'],
      phone: '',
      verify: '',
      countdown: 0,
      timeout: false,
      hassend: false,
      submitLoading: false,
      phone_focus: false,
      verify_focus: false,
      countryCodeList: [],
      checked: false
    };
    return _this;
  }
  _createClass(ActivityLogin, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;
      this._isMount = true;
      getCountryCodeList().then(function (list) {
        if (!_this2._isMount) return;
        _this2.setState({
          countryCodeList: list
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMount = false;
      window.clearInterval(this.senderTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        activityDetail = _this$props.activityDetail,
        loginBtnText = _this$props.loginBtnText,
        color = _this$props.color,
        bgColor = _this$props.bgColor,
        fontSize = _this$props.fontSize,
        _this$props$isModal = _this$props.isModal,
        isModal = _this$props$isModal === void 0 ? true : _this$props$isModal,
        _this$props$styleMode = _this$props.styleMode,
        styleMode = _this$props$styleMode === void 0 ? 'modeA' : _this$props$styleMode,
        _this$props$protocolS2 = _this$props.protocolShow,
        protocolShow = _this$props$protocolS2 === void 0 ? true : _this$props$protocolS2;
      var _ref = activityDetail || {},
        startTime = _ref.startTime,
        endTime = _ref.endTime,
        stock = _ref.stock,
        id = _ref.id;
      // 获取虚拟库存
      var virtualStock = getVirtualStock(startTime, endTime, stock, id);
      var _this$state3 = this.state,
        countryCodeList = _this$state3.countryCodeList,
        areaCode = _this$state3.areaCode,
        phone = _this$state3.phone,
        verify = _this$state3.verify,
        countdown = _this$state3.countdown,
        hassend = _this$state3.hassend,
        submitLoading = _this$state3.submitLoading,
        phone_focus = _this$state3.phone_focus,
        verify_focus = _this$state3.verify_focus,
        timeout = _this$state3.timeout;
      if (styleMode === 'modeB') return /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-modeB",
        style: this.props.style
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-modeB-form-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-modeB-area-code"
      }, /*#__PURE__*/React.createElement(Picker, {
        title: "\u9009\u62E9\u533A\u53F7",
        columns: [countryCodeList],
        value: areaCode,
        onSelect: function onSelect(value) {
          return _this3.setState({
            areaCode: value
          });
        },
        onConfirm: function onConfirm(value) {
          return _this3.setState({
            areaCode: value
          });
        }
      }, function (_, action) {
        return /*#__PURE__*/React.createElement("div", {
          className: "new-activity-login-areacode",
          style: {
            fontSize: '14px'
          },
          onClick: function onClick() {
            return action.open();
          }
        }, "+", areaCode[0]);
      })), /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-modeB-input"
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-modeB-icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: phoneNum,
        alt: "",
        className: "new-activity-login-modeB-icon-img"
      })), /*#__PURE__*/React.createElement("input", {
        className: "new-activity-login-modeB-input-content",
        type: "number",
        value: phone,
        placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7",
        maxLength: areaCode[0] === '86' ? 11 : 20,
        onFocus: function onFocus() {
          return _this3.handleSetFocusStatus('phone', true);
        },
        onBlur: function onBlur() {
          return _this3.handleSetFocusStatus('phone', false);
        },
        onChange: function onChange(e) {
          return _this3.setState({
            phone: e.target.value
          });
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-modeB-form-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-modeB-verify"
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-modeB-icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: verifyNum,
        alt: "",
        className: "new-activity-login-modeB-icon-img new-activity-login-modeB-icon-img-num"
      })), /*#__PURE__*/React.createElement("input", {
        className: "new-activity-login-modeB-input-content",
        type: "number",
        value: verify,
        style: {
          width: '158px'
        },
        placeholder: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801",
        maxLength: 6,
        onFocus: function onFocus() {
          return _this3.handleSetFocusStatus('verify', true);
        },
        onBlur: function onBlur() {
          return _this3.handleSetFocusStatus('verify', false);
        },
        onChange: function onChange(e) {
          var value = e.target.value;
          if (value.length > 6) value = value.slice(0, 6);
          _this3.setState({
            verify: value
          });
        }
      })), /*#__PURE__*/React.createElement(Button, {
        className: "new-activity-login-verifycode ".concat(!countdown ? '' : 'disabled'),
        disabled: !!countdown,
        onClick: this.handleSendVerifyCode,
        style: {
          background: bgColor,
          fontSize: '14px'
        }
      }, !countdown ? hassend ? '重新获取' : '获取验证码' : "".concat(countdown, "\u540E\u91CD\u65B0\u53D1\u9001")), ' '), protocolShow && /*#__PURE__*/React.createElement(ProtocolCheck, {
        showProtocol: true,
        checked: this.state.checked,
        onChange: function onChange(value) {
          return _this3.setState({
            checked: !_this3.state.checked
          });
        },
        agreements: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.specificProductAgreements
      }), /*#__PURE__*/React.createElement(Button, {
        className: "new-activity-login-buy",
        loading: submitLoading,
        disabled: submitLoading,
        onClick: this.handleLoginAndBind,
        style: {
          color: color,
          background: bgColor,
          fontSize: "".concat(fontSize || 14, "px"),
          marginTop: '12px'
        }
      }, loginBtnText || '提交报名'));
      return /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login",
        style: this.props.style
      }, isModal && /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-hd"
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-stock"
      }, /*#__PURE__*/React.createElement("div", {
        className: "fire-img"
      }, /*#__PURE__*/React.createElement("img", {
        src: fire,
        alt: ""
      })), /*#__PURE__*/React.createElement("span", {
        className: "lastStock"
      }, /*#__PURE__*/React.createElement(MockInventory, {
        countStock: virtualStock
      })), /*#__PURE__*/React.createElement("span", null, "/\u4E2A\u4F59\u4F4D")), /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-countdown"
      }, /*#__PURE__*/React.createElement("i", {
        className: "iconfont icondaojishi"
      }), /*#__PURE__*/React.createElement(CountDown, {
        count: 15 * 60 * 1000,
        miniShow: true,
        onOver: this.handleTimeOut
      })), /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-countdown-desc"
      }, !timeout ? '剩余支付时间' : '您已超时，可重新点击下单')), /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-bd"
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-flex new-activity-login-item-input ".concat(phone_focus && 'focus')
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-item-icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: phone_focus ? iphoneImgFocus : iphoneImg,
        alt: "",
        className: "iphone"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-auto new-activity-login-item-slot"
      }, /*#__PURE__*/React.createElement(Picker, {
        title: "\u9009\u62E9\u533A\u53F7",
        columns: [countryCodeList],
        value: areaCode,
        onSelect: function onSelect(value) {
          return _this3.setState({
            areaCode: value
          });
        },
        onConfirm: function onConfirm(value) {
          return _this3.setState({
            areaCode: value
          });
        }
      }, function (_, action) {
        return /*#__PURE__*/React.createElement("div", {
          className: "new-activity-login-areacode",
          onClick: function onClick() {
            return action.open();
          }
        }, "+", areaCode[0], /*#__PURE__*/React.createElement(DownOutline, null));
      })), /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-col new-activity-login-item-ct"
      }, /*#__PURE__*/React.createElement("input", {
        type: "number",
        value: phone,
        placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7",
        maxLength: areaCode[0] === '86' ? 11 : 20,
        onFocus: function onFocus() {
          return _this3.handleSetFocusStatus('phone', true);
        },
        onBlur: function onBlur() {
          return _this3.handleSetFocusStatus('phone', false);
        },
        onChange: function onChange(e) {
          return _this3.setState({
            phone: e.target.value
          });
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-flex new-activity-login-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-flex new-activity-login-item-input ".concat(verify_focus && 'focus')
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-auto new-activity-login-item-icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: verify_focus ? emailImgFocus : emailImg,
        alt: "",
        className: "email"
      })), /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-col new-activity-login-item-ct"
      }, /*#__PURE__*/React.createElement("input", {
        type: "number",
        value: verify,
        placeholder: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801",
        maxLength: 6,
        onFocus: function onFocus() {
          return _this3.handleSetFocusStatus('verify', true);
        },
        onBlur: function onBlur() {
          return _this3.handleSetFocusStatus('verify', false);
        },
        onChange: function onChange(e) {
          var value = e.target.value;
          if (value.length > 6) value = value.slice(0, 6);
          _this3.setState({
            verify: value
          });
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: "new-activity-login-auto"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "new-activity-login-verifycode ".concat(!countdown ? '' : 'disabled'),
        disabled: !!countdown,
        onClick: this.handleSendVerifyCode,
        style: {
          background: bgColor
        }
      }, !countdown ? hassend ? '重新获取' : '获取验证码' : "".concat(countdown, "\u540E\u91CD\u65B0\u53D1\u9001")))), protocolShow && /*#__PURE__*/React.createElement(ProtocolCheck, {
        style: {
          marginTop: '-12px',
          marginBottom: '12px'
        },
        showProtocol: true,
        checked: this.state.checked,
        onChange: function onChange(value) {
          return _this3.setState({
            checked: !_this3.state.checked
          });
        },
        agreements: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.specificProductAgreements
      }), /*#__PURE__*/React.createElement(Button, {
        className: "new-activity-login-buy",
        loading: submitLoading,
        disabled: submitLoading,
        onClick: this.handleLoginAndBind,
        style: {
          color: color,
          background: bgColor,
          fontSize: "".concat(fontSize || 14, "px")
        }
      }, loginBtnText || '提交报名')));
    }
  }]);
  return ActivityLogin;
}(React.Component);
export default ActivityLogin;